import { Container } from "@sembark-travel/ui/base"
import HotelBookingEnquiryEmailTemplate from "../../../../../EmailPdfTemplates/HotelBookingEnquiryEmailTemplate"

import { Helmet } from "react-helmet-async"

const OrganizationHotelBookingEnquiryEmailTemplate = () => {
	return (
		<>
			<Helmet>Hotel Booking Enquiry Email Template</Helmet>
			<Container paddingY="4">
				<HotelBookingEnquiryEmailTemplate />
			</Container>
		</>
	)
}

export default OrganizationHotelBookingEnquiryEmailTemplate
